import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyDhULbSEIiToweMSIa8gHR11HMkZtX6_MU",
    authDomain: "the-tertiary-structure.firebaseapp.com",
    projectId: "the-tertiary-structure",
    storageBucket: "the-tertiary-structure.firebasestorage.app",
    messagingSenderId: "1027887027314",
    appId: "1:1027887027314:web:29779d0e5b5cf050e79eeb",
    measurementId: "G-7822BNVRZQ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const messaging = typeof window !== 'undefined' ? getMessaging(app) : null;
export const appId = 'tertiary-v1';